import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'ngx-icon-selector',
  templateUrl: './icon-selector.component.html',
  styleUrls: ['./icon-selector.component.scss']
})
export class IconSelectorComponent implements OnInit {

  @Input()
  icon: any;

  @Input()
  vertical: boolean = false;

  packs = ["eva","font-awesome"];
  groupClass ="col-sm-6"

  constructor() { }

  ngOnInit(): void {
    if(this.icon == null){
      this.icon = {pack:'',icon:''}
    }
    if(this.vertical){
      this.groupClass = "col-sm-12";
    }
  }

}
